export const startingDate = 'April 01, 2020'